import { gql } from '@apollo/client';
import { getProductFragment } from '../product/getProductQuery';

const getFBRQuery = ({ productDomains = [] }) => {

  const fragments = getProductFragment({ domains: productDomains });
  const FBRQuery = gql`
    query FBRQuery($itemId: String!, $storeId: String = "8119") {
      fbr(itemId: $itemId, storeId: $storeId) {
        recommendedProductSet
        recommendedFeatureSet
        fbrItems {
            recommendedLabel
            universalFeaturesOrder
            imageGuid
            recommendedFeatures {
              name
              value
            }
            product {
                ${fragments.query}
            }
        }
        anchorItemId
        __typename
      }
    }
    ${fragments.fragments}
`;
  return FBRQuery;
};
export default getFBRQuery;
